<template>
  <div>
    <el-autocomplete
      style="width: 50%"
      :placeholder="$t('CampaignForm_Select')"
      clearable
      v-model="model.early_cancel_event_title"
      :fetch-suggestions="querySearchEvents"
      :select-when-unmatched="true"
      :popper-options="{
        modifiers: [
          hidePopover,
          'offset',
          'keepTogether',
          'arrow',
          'applyStyle'
        ]
      }"
      @clear="clearEventsSelection"
    />
    <label-description-toggle
      :value="Number(model.early_cancel_event_filter)"
      :label-text="$t('Campaign_EarlyCancelEventSelector_Toggle_Title')"
      :description-text="$t('Campaign_EarlyCancelEventSelector_Toggle_Desc')"
      size="medium"
      :style="[
        model.early_cancel_event_filter
          ? { 'margin-top': '20px', 'margin-bottom': '20px' }
          : { 'margin-top': '20px' }
      ]"
      @change="onToggleChange"
    />
    <conditions-editor
      style="min-height: 0"
      v-if="model.early_cancel_event_filter"
      ref="conditions-editor"
      v-model="model.early_cancel_event_conditions"
      data-model-name="Campaign"
      data-model-attribute="event_conditions"
      attribute-list-data-url="/push/event-filter/attribute-list-data"
      :preview="false"
      :no-data-alert="false"
      :single-level="true"
    />
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import ConditionsEditor from '@/common/components/ConditionsEditor.vue'
import LabelDescriptionToggle from '@/common/components/form/LabelDescriptionToggle.vue'

export default {
  name: 'EarlyCancelEventSelector',

  components: {
    LabelDescriptionToggle,
    ConditionsEditor
  },

  props: {
    model: {
      type: Object
    }
  },

  computed: {
    eventsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'events',
        params: {
          sort: 'title'
        }
      })
    }
  },

  methods: {
    querySearchEvents(queryString, cb) {
      const params = {
        sort: 'title'
      }

      if (queryString !== null && queryString !== '') {
        params.title = queryString
      }

      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'events',
          params: params
        })
      ).then(({ data }) => {
        const list = data.map(event => {
          return {
            value: event.title,
            type: event.type
          }
        })
        cb(list)
      })
    },

    clearEventsSelection() {
      this.model.early_cancel_event_title = null
    },

    hidePopover(data) {
      const refRect = data.offsets.reference
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64

      data.styles.display = refRect.bottom - headerHeight < 0 ? 'none' : 'block'

      return data
    },

    onToggleChange(value) {
      this.model.early_cancel_event_filter = !!value
    }
  }
}
</script>

<style scoped>
>>> .label-ct {
  width: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/EarlyCancelEventSelector.vue